import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SendEmailFormProps } from "models/propTypes/commonPropTypes";
import { TextInputProps, TextInputWithSuggestionsProps } from "models/propTypes/wintFormPropsTypes";
import { UtilFormTypes } from "models/formTypes";
//#endregion
//#region components
import {
  WintForm,
  TextInput,
  VerticalFormField,
  useWintForm,
  TextAreaInput,
  TextInputWithSuggestions,
} from "components/common/wintForms";
//#endregion

const SendEmailForm: ForwardRefRenderFunction<FormHandles, SendEmailFormProps> = (props, ref) => {
  const { defaultValues, validationSchema, handleSubmit, emailSuggestions, disableSubject, disableMessage } = props;
  const { wintFormProps, connect } = useWintForm<UtilFormTypes.Email>({
    formRef: ref,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<TextInputWithSuggestionsProps>
        Component={TextInputWithSuggestions}
        {...connect("to")}
        label={TranslationKeys.Common.Receiver}
        suggestions={emailSuggestions}
      />
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("subject")}
        label={TranslationKeys.Common.Subject}
        maxLength={512}
        disabled={disableSubject}
      />
      <VerticalFormField<TextInputProps>
        Component={TextAreaInput}
        {...connect("message")}
        label={TranslationKeys.Common.Content}
        disabled={disableMessage}
        minRows={1}
      />
    </WintForm>
  );
};

export default forwardRef(SendEmailForm);
